/**
 * represents a form field of passed type. It wil have a value field of T
 * and and error filed of string to manage the state of a form field
 * @typedef {Object} FormEntry<T>
 * @property {T} value - form field value
 * @property {string} error - error message to be displayed if the field is invalid
 */
export type FormEntry<T> = {
  value?: T;
  error?: string;
};

/**
 * represents map of key to FormEntries
 * @typedef {Object} FormState
 */
export type FormState = Record<string, FormEntry<unknown>>;

/**
 * represents all the properties required for a form
 * @typedef {Object} FormProps<FormState>
 * @property {FormState} [state] - state of the form consists of values and errors
 * @property {string} [error] - form level error to be displayed
 * @property {boolean} [loading] - control form level loading, can be used for button loading, prevent edit etc.
 * @property {function} onChange - called when any value changed in any of the fields;
 */
export type FormProps<FormState> = {
  state?: FormState;
  error?: string;
  loading?: boolean;
  onChange: (change: unknown) => void;
};

/**
 * represents a user location
 * @typedef {Object} UserLocation
 * @property {FormEntry<string>} site - site name of the user location
 * @property {FormEntry<string>} room - room name of the user location
 */
export type UserLocation = {
  site: FormEntry<string>;
  room: FormEntry<string>;
};

/**
 * represents User message from UserMessageForm component
 * @typedef {Object} UserMessage
 * @property {String} code - User Message code
 * @property {String} [message] - Other Message value
 */
export type UserMessage = {
  code: string;
  message?: string;
};

export enum SortOrder {
  DESC = 'DESC',
  ASC = 'ASC',
}
